export default {
  /**
   * In báo cáo tĩnh
   */
  StaticReportRendered: 'static-report-rendered',

  /**
   * In báo cáo chứng từ
   */
  VoucherReportRendered: 'voucher-report-rendered',

  /**
   * In báo cáo động
   */
  DynamicReportRendered: 'dynamic-report-rendered',

  /**
   * Cập nhật DB option
   */
  UpdateDbOption: 'update-db-option',

  /**
   * Invalid cache danh mục
   */
  InvalidCacheDi: 'invalid-cache-di',

  /**
   * Export 1 danh sách
   */
  ExportList: 'export-list',

  /**
   * Cập nhật layout template
   */
  UpdateLayoutTemplate: 'update-layout-template',

  /**
   * Xuất khẩu XML
   */
  ExportXML: 'export-xml',

  /**
   * Xuất khẩu Json
   */
  ExportJson: 'export-json',

  /**
   * Cập nhật vai trò của người dùng
   */
  ChangeRoleOfSysUser: 'change-role-of-sys-user',

  /**
   * Cập nhật quyền hạn realtime khi Admin thay đổi permission của role
   */
  UpdatePermission: 'update-permission',

  /**
   * Xóa người dùng
   */
  DeleteSysUser: 'delete-sys-user',

  /**
   * Có thông báo mới
   */
  NewNotification: 'new-notification',

  /**
   * In báo cáo và gửi hồ sơ sang dvc
   */
  SendDocumentDvc: 'send-document-dvc',

  /**
   * Đang thực hiện ghi sổ, bỏ ghi sổ theo lô
   */
  PostBatchProcess: 'post_batch_process',

  /**
   * Thực hiện ghi sổ, bỏ ghi sổ nhiều chứng từ
   */
  PostMultiCompleted: 'post_multi_completed',

  // Cập nhật danh sách hồ sơ
  UpdateDvcList: 'update_DVC_list',

  /**
   * Bắt đầu sao lưu dữ liệu
   */
  BackupDataStart: 'backup_data_start',

  /**
   * Hủy sao lưu dữ liệu
   */
  BackupDataCancel: 'backup_data_cancel',

  /**
   * Cập nhật % tiến trình sao lưu dữ liệu (realtime từ worker)
   */
  BackupDataProgress: 'backup_data_progress',

  /**
   * Hoàn thành việc sao lưu dữ liệu
   */
  BackupDataCompleted: 'backup_data_completed',

  /**
   * Cập nhật % tiến trình phục hồi dữ liệu (realtime từ worker)
   */
  RestoreDataProgress: 'restore_data_progress',

  /**
   * Hoàn thành việc khôi phục dữ liệu
   */
  RestoreDataCompleted: 'restore_data_completed',
  /**
   * Lấy trạng thái từ DVC
   */
  GetDocumentStatusDvc: 'get-document-status-dvc',

  /**
   * Bắt đầu bảo trì dữ liệu
   */
  DataMaintainStart: 'data_maintain_start',

  /**
   * Bắt đầu tạo dữ liệu từ dữ liệu cũ
   */
  CreateDataPrevYear: 'create_data_prev_year',

  /**
   * Tiến độ tách dữ liệu (event chung — b50/107)
   */
  UpdateCircular: 'update_circular',

  /**
   * Sinh CT từ CT Salagov
   */
  GenerateVoucherFromSalagov: 'generateVoucherFromSalagov',

  /**
   * Kết chuyển nhanh
   */
  QuickTransfer: 'quickTransfer',

  /**
   * Process khóa sổ
   */
  CloseLedgerCompleted: 'close-ledger-completed',

  // / <summary>
  // / Lập báo cáo thành công
  // / </summary>
  CreateSummaryReport: 'create-summary-report',
  // / <summary>
  // / Nộp báo cáo thành công
  // / </summary>
  SubmitSummaryReport: 'submit-summary-report',
  // / <summary>
  // / Lập và nộp báo cáo thành công
  // / </summary>
  CreateAndSubmitSummaryReport: 'create-and-submit-summary-report',
};
